export default __webpack_public_path__ + "static/media/ga-007.dc4b030b.jpg";